import { defineMessages } from 'react-intl';

const messages = defineMessages({
  iconButtonOpened: {
    id: 'pgn.FormAutosuggest.iconButtonOpened',
    defaultMessage: 'Open the options menu',
    description: 'A message shown in case when the autosuggest menu is closed.',
  },
  iconButtonClosed: {
    id: 'pgn.FormAutosuggest.iconButtonClosed',
    defaultMessage: 'Close the options menu',
    description: 'A message shown in case when the autosuggest menu is opened.',
  },
});

export default messages;
